<template>
    <div class="line-charts-pages">
        <div class="charts" ref="lineCharts"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: "LineCharts",
    props: {
        // 数据列表
        list: {
            type: Array,
            default(){
                return [];
            }
        },
        // 线条的颜色
        colors: {
            type: Array,
            default(){
                return ["#0de9e8"];
            }
        }
    },
    data(){
        return {
            myChart: null,
            // 数据
            chartsList: []
        }
    },
    mounted(){
        this.myChart = echarts.init(this.$refs.lineCharts);
        window.addEventListener("resize", this.handleWindowResize);
    },
    methods: {
        initData(){
            if(this.myChart){
                this.initCharts();
            }
        },
        // 初始化
        initCharts(){
            let data = this.chartsList.map(item => {
                return item.programCount;
            });
            const option = {
                color: this.colors,
                animation: true,
                tooltip: {
                    trigger: 'axis',
                    // formatter: '时间:{b}<br />{a}:{c}'
                },
                grid: {
                    left: '6%',
                    top: '10%',
                    right: '4%',
                    bottom: '15%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    // 坐标轴两边留白策略
                    boundaryGap: false,
                    splitLine:{
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    //轴线上的字
                    axisLabel: {
                        show: true,
                        color: '#B8D1D2',
                        fontSize: 10
                    },
                    data: this.chartsList.map(item => {
                        return item.monthStr;
                    })
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 4,
                    offset: 15,
                    splitLine:{
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff',
                        fontSize: 12,
                    }
                },
                series: [{
                    name: '广告上刊趋势',
                    type: 'line',
                    showSymbol: false,
                    smooth: true,
                    itemStyle: {
                        color: '#0DE9E8',
                        borderColor: '#0DE9E8',
                        borderWidth: 1
                    },
                    areaStyle: {
                        //区域填充样式
                        color: new echarts.graphic.LinearGradient(
                            0,
                            0,
                            0,
                            1,
                            [{
                                offset: 0,
                                color: "rgba(14, 232, 231, .4)"
                            },
                            {
                                offset: 1,
                                color: "rgba(14, 232, 231, 0.1)"
                            }
                            ],
                            false
                        ),
                        shadowColor: "rgba(14, 232, 231, 0.1)",
                        shadowBlur: 6
                    },
                    data,
                }]
            };

            this.myChart.setOption(option);
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                this.chartsList = value;
                this.$nextTick(function (){
                    this.initData();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.line-charts-pages{
    display: flex;
    width: 100%;
    height: 100%;
    .charts{
        flex:1;
    }
} 
</style>